import { Settings as SettingsIcon } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/matches', label: 'Matches' },
  { to: '/decks', label: 'Decks' },
  { to: '/meta', label: 'Meta' },
  { to: '/chat', label: 'Chat' },
];

export function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-ugin-border/60 bg-ugin-bg/70 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-4 md:px-8">
        <Link
          to="/"
          className="group flex items-center gap-3 font-display text-2xl tracking-wide text-ugin-text"
          aria-label="Ugin home"
        >
          <UginGlyph />
          <span className="bg-gradient-to-br from-ugin-text via-ugin-accent-soft to-ugin-mystic bg-clip-text text-transparent">
            Ugin
          </span>
        </Link>

        <nav className="hidden gap-1 md:flex" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-3 py-1.5 text-sm font-medium transition-colors duration-150',
                  'hover:text-ugin-text hover:bg-ugin-surface',
                  isActive ? 'text-ugin-text bg-ugin-surface' : 'text-ugin-text-muted',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/settings"
            className="rounded-md p-2 text-ugin-text-muted transition-colors hover:bg-ugin-surface hover:text-ugin-text"
            aria-label="Settings"
          >
            <SettingsIcon className="size-5" />
          </Link>
        </div>
      </div>
    </header>
  );
}

function UginGlyph() {
  // The Ugin sigil — stylized colorless spiral / eye.
  return (
    <svg
      viewBox="0 0 32 32"
      width="32"
      height="32"
      role="img"
      aria-label="Ugin sigil"
      className="text-ugin-accent"
    >
      <defs>
        <radialGradient id="ugin-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0.5" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="16" cy="16" r="14" fill="url(#ugin-glow)" />
      <path
        d="M16 4 C 9 4 4 9 4 16 C 4 23 9 28 16 28 C 23 28 28 23 28 16"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M16 8 C 11 8 8 11 8 16 C 8 21 11 24 16 24"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="16" cy="16" r="2.5" fill="currentColor" />
    </svg>
  );
}
